const validCopyElements = [
  'bpmn:StartEvent',
  'bpmn:IntermediateEvent',
  'bpmn:IntermediateCatchEvent',
  'bpmn:IntermediateThrowEvent',
  'bpmn:EndEvent',
  'bpmn:Task',
  'bpmn:UserTask',
  'bpmn:GlobalTask',
  'bpmn:SubProcess',
  'bpmn:CallActivity',
  'bpmn:ManualTask',
  'bpmn:ScriptTask',
  'bpmn:ServiceTask',
  'bpmn:ExclusiveGateway',
  'bpmn:ParallelGateway',
  'bpmn:InclusiveGateway',
  'bpmn:Gateway',
  'bpmn:EventBasedGateway',
  'bpmn:TextAnnotation',
];

export default validCopyElements;
